import React, { useEffect, useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import FullCalendar from '@fullcalendar/react';
import Loader from '../components/Loader';
// FullCalendar plugin import order does matter here
import listPlugin from '@fullcalendar/list';
import dayGridPlugin from '@fullcalendar/daygrid';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Calendar as PRCalendar } from 'primereact/calendar';
import EventService from '../service/EventsService';
import ReactTooltip from 'react-tooltip';
import { useHistory } from 'react-router-dom';
import { ET_OFFSET } from '../utilities/constants';
import { getTimeInEtTimezone } from '../utilities/functions';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import EventTooltipComponent from '../components/CalendarPage/EventTooltipComponent';
import handleDatesRender from '../components/CalendarPage/fullcalendar/functions';
import { VideoValidator } from '../components/PlaylistPage/VideoValidator';

export const CalendarPage = props => {
  const [eventDialog, setEventDialog] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [clickedEvent] = useState(null);
  const [changedEvent, setChangedEvent] = useState({
    title: '',
    start: null,
    end: null,
    allDay: null,
  });
  const [events, setEvents] = useState(null);
  const [videoValidator, setVideoValidator] = useState(false);
  const [eventsDate, setEventsDate] = useState(null);

  const tooltipRef = useRef();
  const toast = useRef(null);
  const calendarRef = React.createRef();
  const history = useHistory();

  useEffect(() => {
    document.title = 'Hub | Home';
    setBreadcrumb();

    // invalidate cached events if the user logs in under a different club account
    const previousClub = localStorage.getItem('previousUserClub');

    if (!props.user.club || props.user.club != previousClub) {
      // comparing string and int
      console.log('Different club login. Invalidate cached events');
      localStorage.removeItem('cachedEvents');
      localStorage.removeItem('cacheTimestamp');
      localStorage.setItem('previousUserClub', props.user.club || '');
    }

    const cachedEvents = localStorage.getItem('cachedEvents');
    const cacheTimestamp = localStorage.getItem('cacheTimestamp');
    const cacheExpiryTime = 60 * 60 * 1000; // 1 hour
    const sinceCached = Date.now() - cacheTimestamp;

    if (cachedEvents && cacheTimestamp && sinceCached < cacheExpiryTime) {
      setEvents(JSON.parse(cachedEvents));
      console.log('Using cached events');
    } else {
      const eventService = new EventService();
      console.log('Events fetched from the DB');
      eventService.getCalendarEventsV3(props.user).then(data => {
        const hour = 60 * 60 * 1000;
        const convertedEvents = data.map(event => {
          const d = new Date(event.et_time);
          const etDateTime = d.getTime() + ET_OFFSET * hour;
          return {
            id: event.id,
            outputs: event.outputs,
            title: event.name,
            et: event.et_time,
            start: etDateTime,
          };
        });

        setEvents(convertedEvents);
        localStorage.setItem('cachedEvents', JSON.stringify(convertedEvents));
        localStorage.setItem('cacheTimestamp', Date.now());
      });
    }
  }, [props.user.club]);

  const setBreadcrumb = () => {
    const breadcrumbDiv = document.getElementsByClassName('layout-breadcrumb viewname')[0];
    const breadcrumbText = `Game Schedule`;
    breadcrumbDiv.innerHTML = breadcrumbText;
  };
  const reset = () => {
    setEventDialog(false);
  };

  const footer = (
    <>
      <Button
        type="button"
        label="Cancel"
        icon="pi pi-refresh"
        className="p-button-text"
        onClick={reset}
      />
    </>
  );

  const openEventPage = eventInfo => {
    const id = eventInfo.id;
    if (props.user.club === 1)
      id && history.push({ pathname: `/event/${id}`, state: { metaInfo: eventInfo } });
  };
  const openPlaylistPage = id => {
    id && history.push({ pathname: `/playlist/${id}`, state: {} });
  };

  function timeFormat(info) {
    let hours = info.date.hour;
    let minutes = info.date.minute;
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    const strTime = hours + ':' + minutes + ampm + ' ET';

    return <span style={{ fontSize: '0.9rem', fontWeight: 600 }}>{strTime}</span>;
  }
  const CalendarEventTitle = props => {
    const isListView = props.eventInfo.view.type === 'listMonth';
    const titleParts = props.eventInfo.event.title.replace(/\s/g, '').split('@');

    let standardName = false; // XXX @ YYY || XXX@YYY

    if (titleParts.length === 2) {
      if (titleParts[0].length === 3 && titleParts[1].length === 3) standardName = true;
    }
    return (
      <span className="calendarEventTitle">
        {standardName ? (
          <span>
            {isListView ? (
              <span>
                <span className="calendarTeamName">{titleParts[0]}</span>
                <span>&nbsp;&nbsp;@&nbsp;&nbsp;</span>
                <span className="calendarTeamName" style={{ width: 36 }}>
                  {titleParts[1]}&nbsp;&nbsp;
                </span>
              </span>
            ) : (
              <span>
                <span className="calendarTeamName">{titleParts[0]}</span>
                <span>&nbsp;@&nbsp;</span>
                <span className="calendarTeamName">{titleParts[1]}</span>
              </span>
            )}
          </span>
        ) : (
          props.eventInfo.event.title
        )}
        <span className="calendarEventLocation">
          {' '}
          {getTimeInEtTimezone(props.eventInfo.event._def.extendedProps.et)}
        </span>
      </span>
    );
  };
  const renderEventContent = eventInfo => {
    const numOfOutputs = eventInfo.event._def.extendedProps.outputs.length;

    if (!eventInfo) return null;
    return (
      <div>
        <span
          onClick={() => {
            if (eventInfo.event._def.extendedProps.outputs.length > 0)
              openPlaylistPage(eventInfo.event._def.extendedProps.outputs[0].id);
            else
              toast.current.show({
                severity: 'warn',
                summary: 'No playlists for this event so far',
                detail: 'No playlists',
                life: 4000,
              });
          }}
          className="calendarEventLink"
        >
          <CalendarEventTitle eventInfo={eventInfo} />
        </span>
        &nbsp;
        <span
          data-event="click focus"
          data-tip={eventInfo.event.id}
          data-for="eventTooltipId"
          id={'id' + eventInfo.event.id}
        >
          {numOfOutputs > 0 ? (
            <i className="pi pi-external-link calendarEventTooltipIconBlue"></i>
          ) : (
            <i className="pi pi-external-link calendarEventTooltipIconGrey"></i>
          )}
        </span>
        <ReactTooltip
          ref={tooltipRef}
          id="eventTooltipId"
          globalEventOff="click"
          className="eventTooltip card"
          getContent={eventId => {
            if (!eventId) return null;
            return (
              <EventTooltipComponent
                id={eventId}
                events={events}
                openEventPage={openEventPage}
                openPlaylistPage={openPlaylistPage}
                tooltipRef={tooltipRef}
              />
            );
          }}
          effect="solid"
          delayHide={10}
          delayUpdate={10}
          place={'bottom'}
          type={'light'}
        />
      </div>
    );
  };

  const handleDates = info => {
    handleDatesRender(info, setVideoValidator, setEventsDate);
  };
  /*
   ***  MAIN  ***
   */

  return (
    <div className="p-grid">
      <div className="p-col-12">
        {videoValidator && (
          <VideoValidator
            isOpen={videoValidator}
            handleClose={() => setVideoValidator(false)}
            event={null}
            date={eventsDate}
          />
        )}
        <div className="card card-container">
          {showDatePicker && (
            <DatePicker
              fixedHeight
              dateFormat="MM/yyyy"
              inline
              showMonthYearPicker
              onChange={date => {
                calendarRef.current
                  .getApi()
                  .gotoDate(new Date(date.getTime() + 5 * 24 * 60 * 60 * 1000));
                setShowDatePicker(false);
              }}
            />
          )}

          <Toast ref={toast} />
          {events ? (
            <FullCalendar
              ref={calendarRef}
              height={'auto'}
              timeZone="America/New York"
              events={events}
              plugins={[dayGridPlugin, listPlugin]}
              // hide weekday in list view
              listDaySideFormat={false}
              themeSystem={'bootstrap'}
              eventTimeFormat={timeFormat}
              headerToolbar={{
                left: 'twoMonthBack,prev,gotoButton,next,twoMonthFwd',
                center: 'title',
                initialView: 'dayGridMonth',
                right: 'dayGridMonth,listMonth',
              }}
              customButtons={{
                gotoButton: {
                  text: (
                    <i
                      title="Jump to month"
                      className="layout-menuitem-icon pi pi-fw pi-calendar"
                    />
                  ),
                  click: () => {
                    setShowDatePicker(prevShowDatePicker => !prevShowDatePicker);
                  },
                },
                twoMonthBack: {
                  icon: 'chevrons-left',
                  text: 'Two months back',
                  click: () => {
                    const api = calendarRef.current.getApi();
                    api.incrementDate({ months: -2 });
                  },
                },
                twoMonthFwd: {
                  icon: 'chevrons-right',
                  text: 'Two months forward',
                  click: () => {
                    const api = calendarRef.current.getApi();
                    api.incrementDate({ months: 2 });
                  },
                },
              }}
              buttonText={{ month: 'Calendar', list: 'List' }}
              defaultTimedEventDuration={0}
              firstDay={1}
              // editable
              selectable
              fixedWeekCount={false}
              eventContent={renderEventContent}
              datesSet={handleDates}
            />
          ) : (
            <Loader />
          )}
          <Dialog
            visible={eventDialog && !!clickedEvent}
            style={{ width: '450px' }}
            header="Event Details"
            footer={footer}
            modal
            closable
            onHide={() => setEventDialog(false)}
          >
            <div className="p-fluid">
              <div className="p-field">
                <label htmlFor="title">Title</label>
                <InputText
                  id="title"
                  value={changedEvent.title}
                  onChange={e => setChangedEvent({ ...changedEvent, ...{ title: e.target.value } })}
                  required
                  autoFocus
                />
              </div>
              <div className="p-field">
                <label htmlFor="start">Time</label>
                <PRCalendar
                  id="start"
                  value={changedEvent.start}
                  onChange={e => setChangedEvent({ ...changedEvent, ...{ start: e.value } })}
                  showTime
                  appendTo={document.body}
                />
              </div>
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
};
